<template>
    <div v-if="member">
        <div v-if="query" class="form-text">
            <h5 class="d-inline">{{`${$t('Most recent data')}: `}}</h5>
            <h5 class="d-inline">{{ query.query.evaluationTime | formatDate }}</h5>
        </div>
        <fg-input class="btn-one-size-dropdown btn-one-size pt-2">
            <el-select size="large"
                       class="select-primary"
                       fullWidth
                       @change="redirectMember"
                       :value="$route.params.mid">
                <el-option v-for="option in membersList"
                           :value="option._id"
                           :label="option.user.firstName + ' ' + (option.user.lastName ? option.user.lastName : '')"
                           :key="option._id">
                </el-option>
            </el-select>
        </fg-input>
        <div class="row">
            <div class="col-sm-12 collapsible">
                <layout-wrapper v-if="member.datasets" v-for="(dataset, key) in member.datasets"
                                :key="key"
                                class-name="d-inline-block pl-2 pr-3"
                                :length="Object.keys(member.datasets).length">
                    <template slot="body">
                        <chart :data="dataset"
                               :badge-value="dataset.average"
                               :title="dataset.title | languageString"
                               link=""
                               :alertActive="dataset.alertActive"
                               icon="fa fa-bullhorn"/>
                    </template>
                </layout-wrapper>
            </div>
        </div>
        <div class="col-sm-12"><hr></div>
        <div class="col-sm-12">
            <card class="card-plain user-questionnaire">
                <div v-if="questions">
                    <query-result v-model="questions"/>
                </div>
            </card>
        </div>
        <div class="col-sm-12"><hr></div>

        <div class="col-sm-12 pl-0">
            <card class="card-plain user-questionnaire">
                <div v-if="questions">
                    <TeamMemberHistory 
                      :isUserOwner="$auth.user.isOwner || $auth.user.isLeader"
                      :questionnaireId="$route.params.qid"
                      :teamId="$route.params.tid"
                      :memberId="member._id"
                      />
                </div>
            </card>
        </div>
    </div>
</template>

<script>
  import { Button, Select, Option } from 'element-ui'
  import Chart from '../../Dashboard/Components/BasicChart'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import QueryResult from '../../Dashboard/Components/BasicQueryResult'
  import LayoutWrapper from '../../UIComponents/LayoutWrapper'
  import TeamMemberHistory from './TeamMemberHistory'
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    name: 'TeamMemberView',
    components: {
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
      Chart,
      ChartCard,
      QueryResult,
      LayoutWrapper,
      TeamMemberHistory
    },
    props: {
      member: {
        type: Object
      },
      membersList: {
        type: Array
      }
    },
    computed: {
      ...mapState('user/teams/lastQueryByUser', {
        query: state => state.item
      }),
      ...mapGetters({
        getQuestionsGropedByType: 'user/teams/lastQueryByUser/getQuestionsGropedByType'
      }),
      questions: function () {
        return this.getQuestionsGropedByType()
      }
    },
    methods: {
      ...mapActions('user/teams/lastQueryByUser', ['getItem']),
      checkPackage (allowedPackages) {
        return allowedPackages.includes(this.$auth.user.customer.settings.contract.packageType)
      },
      redirectMember (value) {
        this.$router.push({ name: 'TeamViewMember', params: {qid: this.$route.params.qid, tid: this.$route.params.tid, mid: value } })
        //console.log(value)
      }
    },
    watch: {
      member: {
        handler () {
          this.getItem({
            questionnaireId: this.$route.params.qid,
            teamId: this.$route.params.tid,
            memberId: this.$route.params.mid
          })
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>

<style lang="scss">
  .team-container .card-plain .card-body {
      padding-top: 15px !important;
  }
    
  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
  }
</style>